import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { ClientBookingConfigsService } from '../services/client_booking_configs.service'
import { BookingSearchConfigsClientDto } from '../types'
import { defaultQueryOptions } from './common'

export const useClientBookingConfigs = (
  locationName: string,
  serviceTypeName: string
): UseQueryResult<BookingSearchConfigsClientDto, unknown> => {
  return useQuery<BookingSearchConfigsClientDto>({
    queryKey: ['clientBookingConfigs', locationName, serviceTypeName],
    queryFn: () => ClientBookingConfigsService.getData(locationName, serviceTypeName),
    ...defaultQueryOptions,
  })
}
